<template>
    <tr>
        <td class="TORCod">
        <span>Codice ricambio</span> {{this.ricambio.CodiceArticolo}}
        </td>
        <td class="TORRic">
        <span>Descrizione ricambio</span>{{this.ricambio.DescrizioneArticolo}}
        </td>
        <td class="TORUni"><span>Unità mis.</span>{{this.ricambio.UnitaMisura}}</td>
        <td class="TORQtp"><span>Q.tà prevista</span>{{this.ricambio.QtaPrevista}}</td>
        <td class ="TORQtp"><span>Magazzino</span>
            <select ref="Magazzino" v-model="this.codiceMagazzino">
                <option value="">Seleziona</option>
                <option v-for="magazzino in this.$store.getters.getMagazzini" :key="magazzino.CodiceMagazzino" :value="magazzino.CodiceMagazzino">{{ magazzino.DescrizioneMagazzino }}</option>                              
            </select>
        </td>
        <td class="TORQty">
            <span>Q.tà effettiva</span>
            <form class="Form TableForm">
                <div class="FormRow">
                    <div class="FormBoxWide QIInput">
                        <input type="text" id="" name="" placeholder="" v-model="this.quantitaEffettiva" />
                    </div>
                    <div class="RefreshLineButton">
                        <a href="javascript:void(0)" @click="this.updateRicambio()">Aggiorna</a>
                    </div>
                </div>
            </form>
        </td>
    </tr>
</template>

<script>

import {apiMixin} from "/mixin.js";

export default {
    name: "RicambioRiga",
    props:{
        ricambio: Object
    },
    data(){
        return {
            quantitaEffettiva: this.ricambio.QtaEffettiva,
            codiceMagazzino:""
        }
    },
    mixins: [apiMixin],
    mounted:function(){ 
        this.codiceMagazzino = this.ricambio.CodiceMagazzino;
    },
    methods: {
        updateRicambio(){
            let dataUpdate = {
                SysChiaveglobale: this.ricambio.SysChiaveglobale,
                QtaEffettiva: this.quantitaEffettiva,
                CodiceMagazzino: this.codiceMagazzino
            };
            if(this.quantitaEffettiva == 0){
                this.doApiCall("post","interventi/DeleteRicambio", this.$store.getters.getUtente.Token, null, dataUpdate).then((data) => {
                    this.$toast.success("Ricambio eliminato con successo!", {position:"top-right"});  
                    let idx = this.$parent.$data.listaRicambi.findIndex((item) =>{ return this.ricambio.SysChiaveglobale == item.SysChiaveglobale;});
                    this.$parent.$data.listaRicambi.splice(idx,1);
                    this.$parent.$forceUpdate();
                    this.$vfm.hide('popUpAggiungiRicambio'); 
                });
            }else{
                this.doApiCall("post", "interventi/UpdateRicambio", this.$store.getters.getUtente.Token, null, dataUpdate).then(
                    (data) => {  
                        if(data && data.StatusCode === 200){                    
                            this.$toast.success("Ricambio aggiornato con successo!", {position:"top-right"});  

                            let index = this.$parent.$data.listaRicambi.findIndex(item => {return item.SysChiaveglobale === data.Data.SysChiaveglobale});
                            if(index >= 0) this.$parent.$data.listaRicambi[index] = data.Data; 
                            this.$parent.$forceUpdate();                 
                        }
                        else{
                            this.$toast.error("Attenzione! Si sono verificati errori durante l'aggiornamento del ricambio!", {position:"top-right"});
                        }
                    }
                );
            }
        }
    }
    
}
</script>
